module.exports = __webpack_public_path__ + "img/pathfinder-contrast.0d9af7e6.svg";